<template>
  <div class="session-group-tabs">
    <div
      v-for="group in yearGroups"
      :key="group.year"
      class="year-group"
    >
      <button
        type="button"
        class="year-header"
        :class="{ expanded: expandedYears[group.year] }"
        @click="toggleYear(group.year)"
      >
        <span class="year-title">{{ group.year }}年</span>
        <span class="year-count">{{ group.sessions.length }} 场</span>
        <i
          class="fas year-chevron"
          :class="expandedYears[group.year] ? 'fa-chevron-down' : 'fa-chevron-right'"
        ></i>
      </button>

      <div
        v-show="expandedYears[group.year]"
        class="session-tabs"
      >
        <button
          v-for="session in group.sessions"
          :key="session.id"
          type="button"
          class="session-tab"
          :class="{ active: session.id === value }"
          @click="selectSession(session.id)"
        >
          {{ session.label }}
          <span v-if="session.version" class="version-tag">v{{ session.version }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { buildSessionGroups, resolveExpandedYears } from '../utils/sessions';

export default {
  name: 'SessionGroupTabs',
  props: {
    sessions: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      expandedYears: {},
    };
  },
  computed: {
    yearGroups() {
      return buildSessionGroups(this.sessions);
    },
  },
  watch: {
    sessions: {
      immediate: true,
      handler() {
        this.expandedYears = resolveExpandedYears(this.yearGroups, this.value);
      },
    },
    value(sessionId) {
      this.expandedYears = resolveExpandedYears(this.yearGroups, sessionId);
    },
  },
  methods: {
    toggleYear(year) {
      this.expandedYears = {
        ...this.expandedYears,
        [year]: !this.expandedYears[year],
      };
    },
    selectSession(id) {
      if (id !== this.value) {
        this.$emit('input', id);
        this.$emit('change', id);
      }
    },
  },
};
</script>

<style scoped>
.session-group-tabs {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 15px;
}

.year-group {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
  background: #fafafa;
}

.year-header {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 15px;
  color: #333;
  transition: background 0.2s ease;
}

.year-header:hover {
  background: #f0f0f0;
}

.year-header.expanded {
  border-bottom: 1px solid #e8e8e8;
  background: #f5f5f5;
}

.year-title {
  font-weight: 600;
}

.year-count {
  margin-left: 8px;
  font-size: 13px;
  color: #999;
}

.year-chevron {
  margin-left: auto;
  font-size: 12px;
  color: #999;
}

.session-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  padding: 4px 8px 8px;
  background: #fff;
}

.session-tab {
  position: relative;
  padding: 10px 18px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 15px;
  color: #666;
  transition: all 0.2s ease;
}

.session-tab:hover {
  color: #333;
}

.session-tab.active {
  color: #42b983;
  font-weight: bold;
}

.session-tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20%;
  width: 60%;
  height: 2px;
  background-color: #42b983;
  border-radius: 1px;
}

.version-tag {
  margin-left: 4px;
  font-size: 11px;
  color: #999;
  font-weight: normal;
}
</style>
